import { decodeHtmlEntities } from "@/utilities/decodeHtmlEntities";

export type LayoutBlock = Record<string, unknown> & {
  blockName?: string | null;
  previewAdminTarget?: string;
  blockType?: string;
};

export const asString = (value: unknown): string | undefined => {
  if (typeof value !== "string") return undefined;

  const decoded = decodeHtmlEntities(value);
  return decoded && decoded.trim().length > 0 ? decoded : undefined;
};

export const asBoolean = (value: unknown): boolean | undefined =>
  typeof value === "boolean" ? value : undefined;

export const asArray = (value: unknown): unknown[] =>
  Array.isArray(value) ? value : [];

export const richTextToPlainText = (value: unknown): string | undefined => {
  if (typeof value === "string") return asString(value);
  if (!(typeof value === "object" && value)) return undefined;

  const root = "root" in value ? (value as { root?: unknown }).root : undefined;
  if (!(typeof root === "object" && root)) return undefined;

  const collectText = (node: unknown): string[] => {
    if (!(typeof node === "object" && node)) return [];

    const maybeText =
      "text" in node ? (node as { text?: unknown }).text : undefined;
    const currentText =
      typeof maybeText === "string"
        ? [decodeHtmlEntities(maybeText) ?? maybeText]
        : [];

    const children =
      "children" in node
        ? (node as { children?: unknown }).children
        : undefined;
    if (!Array.isArray(children)) return currentText;

    return [...currentText, ...children.flatMap((child) => collectText(child))];
  };

  const lines = collectText(root)
    .map((line) => line.trim())
    .filter(Boolean);
  return lines.length ? lines.join(" ") : undefined;
};
